import React, { Fragment, useEffect, useState, useRef } from 'react';
import { getApi } from '../../api/endpoints';
import Multiselect from 'multiselect-react-dropdown';
import HeadUserFilters from '../../models/HeadUserFilters';
import ToggleSwitch from '../../components/ToggleSwitch';
import { useSelector } from 'react-redux';
import { selectQueryParams } from '../../ui/customerListingReducer';

const FiltersFormPartial = (props) => {
  const { headUserFilters, setHeadUserFilters, reset } = props;
  let headUserFiltersObj = new HeadUserFilters(headUserFilters);
  const [zonesApi] = getApi('zones');
  const [zones, setZones] = useState([]);
  const [branchesApi] = getApi('branches');
  const [branches, setBranches] = useState([]);
  const [clustersApi] = getApi('clusters');
  const [clusters, setClusters] = useState([]);
  const [usersTypesApi] = getApi('usersTypes');
  const [headUsers, setHeadUsers] = useState([]);
  const queryParams = useSelector(selectQueryParams);
  const refs = {
    zone_ids_ref: useRef(),
    branch_ids_ref: useRef(),
    cluster_ids_ref: useRef(),
    status_ref: useRef(),
    users_type_ids_ref: useRef()
  }

  useEffect(() => {
    refs.zone_ids_ref.current.resetSelectedValues();
    refs.branch_ids_ref.current.resetSelectedValues();
    refs.cluster_ids_ref.current.resetSelectedValues();
    refs.users_type_ids_ref.current.resetSelectedValues();
    headUserFiltersObj.zone_ids = queryParams.filters?.zone_ids;
    headUserFiltersObj.branch_ids = queryParams.filters?.branch_ids;
    headUserFiltersObj.cluster_ids = queryParams.filters?.cluster_ids;
    headUserFiltersObj.users_type_ids = queryParams.filters?.users_type_ids;
    setHeadUserFilters(headUserFiltersObj.toStateJson());
  }, [reset])

  useEffect(() => {
    fetchOptions(zonesApi, "zones", { fields: "options" }, setZones);
    fetchOptions(usersTypesApi, "users_types", { filters:{ head_users_types: true }, fields: "options" }, setHeadUsers);
    if(headUserFiltersObj?.zone_ids && headUserFiltersObj?.zone_ids.length > 0){
      fetchOptions(branchesApi, "branches", { fields: "options", filters: { zone_ids: headUserFiltersObj.zone_ids } }, setBranches);
    }
    if(headUserFiltersObj?.branch_ids && headUserFiltersObj?.branch_ids.length > 0){
      fetchOptions(clustersApi, "clusters", { fields: "options", filters: { branch_ids: headUserFiltersObj.branch_ids } }, setClusters);
    }
  }, []);

  const fetchOptions = async (api, key, params = {}, setFunction) => {
    try {
      const response = await api(params).unwrap();
      setFunction(response.data[key]);
    } catch (error) {
    }
  }

  const onZoneSelect = (key, selectedItem, selectedList) => {
    headUserFiltersObj[key].push(selectedItem.id);
    validateValue(key);
    setHeadUserFilters(headUserFiltersObj.toStateJson());
    if(key == "zone_ids") fetchOptions(branchesApi, "branches", { fields: "options", filters: { zone_ids: selectedList.map(item => item.id)} }, setBranches);
  }

  const onZoneRemove = (key, removedItem) => {
    headUserFiltersObj[key] = headUserFiltersObj[key].filter((item) => item !== removedItem.id);
    validateValue(key);
    setClusters([]);
    headUserFiltersObj.cluster_ids = [];
    headUserFiltersObj.branch_ids = [];
    refs.branch_ids_ref.current.resetSelectedValues();
    refs.cluster_ids_ref.current.resetSelectedValues();
    if(headUserFiltersObj.zone_ids.length !== 0){
      fetchOptions(branchesApi, "branches", { fields: "options", filters: { zone_ids: headUserFiltersObj.zone_ids} }, setBranches);
    } else{
      setBranches([]);
    }
    setHeadUserFilters(headUserFiltersObj.toStateJson());
  }

  const onBranchSelect = (key, selectedItem, selectedList) => {
    headUserFiltersObj[key].push(selectedItem.id);
    validateValue(key);
    setHeadUserFilters(headUserFiltersObj.toStateJson());
    fetchOptions(clustersApi, "clusters", { fields: "options", filters: { branch_ids: selectedList.map(item => item.id) } }, setClusters);
  }

  const onBranchRemove = (key, removedItem) => {
    headUserFiltersObj[key] = headUserFiltersObj[key].filter((item) => item !== removedItem.id);
    validateValue(key);
    headUserFiltersObj.cluster_ids = [];
    refs.cluster_ids_ref.current.resetSelectedValues();
    if(headUserFiltersObj.branch_ids.length !== 0){
      fetchOptions(clustersApi, "clusters", { fields: "options", filters: { branch_ids: headUserFiltersObj.branch_ids} }, setClusters);
    } else {
      setClusters([]);
    }
    setHeadUserFilters(headUserFiltersObj.toStateJson());
  }

  const onClusterSelect = (key, selectedItem) => {
    headUserFiltersObj[key].push(selectedItem.id);
    validateValue(key);
    setHeadUserFilters(headUserFiltersObj.toStateJson());
  }

  const onClusterRemove = (key, removedItem) => {
    headUserFiltersObj[key] = headUserFiltersObj[key].filter((item) => item !== removedItem.id);
    validateValue(key);
    setHeadUserFilters(headUserFiltersObj.toStateJson());
  }

  const validateValue = (field) => {
    headUserFiltersObj.validate(field);
  }

  return <Fragment>
    <div className="row pt-4 row-cols-md-5">
      <div className="col my-2">
        <label htmlFor='zone_ids' className="form-label mb-0">Zone</label>
        <Multiselect
          id='zone_ids'
          options={zones}
          selectedValues={zones.filter((zone) => headUserFiltersObj.zone_ids.includes(zone.id))}
          onSelect={(selectedList, selectedItem) => onZoneSelect("zone_ids", selectedItem, selectedList)}
          onRemove={(selectedList, removedItem) => onZoneRemove("zone_ids", removedItem)}
          placeholder='Select from options'
          displayValue={'name'}
          showArrow={true}
          customArrow={true}
          avoidHighlightFirstOption={true}
          ref={refs.zone_ids_ref}
        />
        <div id="mobile_number_help" className="form-text text-danger mt-0">
          {headUserFiltersObj.errors.zone_ids}
        </div>
      </div>
      <div className="col my-2">
        <label htmlFor='branch_ids' className="form-label mb-0">Circle</label>
        <Multiselect
          id='branch_ids'
          options={branches}
          selectedValues={branches.filter((branch) => headUserFiltersObj.branch_ids.includes(branch.id))}
          onSelect={(selectedList, selectedItem) => onBranchSelect("branch_ids", selectedItem, selectedList)}
          onRemove={(selectedList, removedItem) => onBranchRemove("branch_ids", removedItem)}
          placeholder='Select from options'
          displayValue={'name'}
          showArrow={true}
          customArrow={true}
          avoidHighlightFirstOption={true}
          ref={refs.branch_ids_ref}              
        />
      </div>
      <div className="col my-2">
        <label htmlFor='cluster_ids' className="form-label mb-0">Cluster</label>
        <Multiselect
          id='cluster_ids'
          options={clusters}
          selectedValues={clusters.filter((cluster) => headUserFiltersObj.cluster_ids.includes(cluster.id))}
          onSelect={(selectedList, selectedItem) => onClusterSelect("cluster_ids", selectedItem)}
          onRemove={(selectedList, removedItem) => onClusterRemove("cluster_ids", removedItem)}
          placeholder='Select from options'
          displayValue={'name'}
          showArrow={true}
          customArrow={true}
          avoidHighlightFirstOption={true}
          ref={refs.cluster_ids_ref}   
        />
      </div>
      <div className="col my-2">
        <label htmlFor='users_type_ids' className="form-label mb-0">Users Type</label>
        <Multiselect
          id='users_type_ids'
          options={headUsers}
          selectedValues={headUsers.filter((userType) => headUserFiltersObj.users_type_ids.includes(userType.id))}
          onSelect={(selectedList, selectedItem) => onZoneSelect("users_type_ids", selectedItem, selectedList)}
          onRemove={(selectedList, removedItem) => onZoneRemove("users_type_ids", removedItem)}
          placeholder='Select from options'
          displayValue={'role_name'}
          showArrow={true}
          customArrow={true}
          avoidHighlightFirstOption={true}
          ref={refs.users_type_ids_ref}
        />
        <div id="mobile_number_help" className="form-text text-danger mt-0">
          {headUserFiltersObj.errors.users_type_ids}
        </div>
      </div>
      <div className="col my-2">
        <label htmlFor='active' className="form-label mb-0">Status</label>
        <ToggleSwitch
          id="active"
          label_left="Inactive"
          label_right ="Active"
          onChange={(e) => {
            headUserFiltersObj.active = !headUserFiltersObj.active;
            setHeadUserFilters(headUserFiltersObj.toStateJson());
          }}
          checked={headUserFiltersObj.active}
          className="form-control"
        />
      </div>
    </div>
  </Fragment>
}

export default FiltersFormPartial;
